import React, { useEffect, useState } from "react";
import NimbusModal from "../../../fragments/NimbusModal";
import InputText from "../../../fragments/Inputs/InputText";
import CancelButton from "../../../fragments/Buttons/CancelButton";
import SubmitButton from "../../../fragments/Buttons/SubmitButton";
import useFormSubmit from "../../../hooks/useFormSubmit";
import useValidateForm from "../../../hooks/useValidateForm";
import { toast } from "react-toastify";
import alertConfiguration from "../../../utils/alertsUtils";
import { putComisionUsoPersonalizada } from "../../../services/Api/MarketPlace/ComisionUsoPlataforma";

const COMISION_SCHEMA = {
  comision: "",
};

const ComisionUsoPlataformaModal = ({
  isOpen,
  setIsOpen,
  estructura,
  comisionDeUso,
  tipoEstructura,
  obtenerCuentasComerciales,
}) => {
  const handleSubmitComision = async () => {
    if (Object.keys(errors).length === 0) {
      try {
        let body = {
          [tipoEstructura]: {
            _id: estructura._id,
          },
          comisionDeUso: parseInt(values.comision),
        };
        await putComisionUsoPersonalizada(body);
        toast.success("Comisión de uso  personalizada guardada correctamente.", alertConfiguration);
        obtenerCuentasComerciales();
        setIsOpen(false);
      } catch (error) {
        console.log(error);
        setIsOpen(false);
      }
    } else {
      setErrors(errors);
      setIsEnableSubmitButton(true);
    }
  };

  const [formStatus, handleSubmit] = useFormSubmit(handleSubmitComision);
  const { handleChange, errors, values, isEnableSubmitButton, setIsEnableSubmitButton, setValues, setErrors } =
    useValidateForm(COMISION_SCHEMA);

  useEffect(() => {
    setValues({ comision: comisionDeUso });
    if (!isOpen) {
      setErrors({})
      setIsEnableSubmitButton(false)
    };
  }, [isOpen]);

  useEffect(() => {
    if (values.comision === "") setIsEnableSubmitButton(false);
  }, [values.comision]);

  return (
    <NimbusModal isOpen={isOpen}>
      <h1 className="text-nimbusDark font-bold px-4">Configurar comisión de uso de la plataforma</h1>
      <p className="w-96 px-4">
        Al configurar la comisión de uso de la plataforma de está estructura específica, no se modifica el porcentaje de
        las demás.
      </p>
      <div className="w-96 px-4 flex flex-col gap-2">
        <p className="font-bold">Nombre de la estructura:</p>
        <p className="break-words">{estructura.nombre}</p>
      </div>
      <div className="w-3/3 px-4 text-left text-xs">
        <InputText
          name="comision"
          placeholder="Ingrese la comisión de uso"
          label="Comisión de uso de la plataforma (%)"
          value={values.comision}
          error={errors["comision"]}
          styles="!w-full"
          labelStyles="text-sm"
          onChange={(e) => handleChange(e, "comision")}
        />
      </div>
      <div className="flex justify-center gap-x-4">
        <CancelButton text="Cancelar" bgColor="bg-divider" onClick={() => setIsOpen(false)} />
        <SubmitButton
          text="Guardar"
          disabled={formStatus === "submitting" || !isEnableSubmitButton}
          onClick={handleSubmit}
        />
      </div>
    </NimbusModal>
  );
};

export default ComisionUsoPlataformaModal;
